import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, debounceTime, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_PERMISSIONS_SEARCH_FETCH = 'TRN_PERMISSIONS_SEARCH_FETCH'
export const TRN_PERMISSIONS_SEARCH_FETCH_CANCELED = 'TRN_PERMISSIONS_SEARCH_FETCH_CANCELED'
export const TRN_PERMISSIONS_SEARCH_FETCH_ERROR = 'TRN_PERMISSIONS_SEARCH_FETCH_ERROR'
export const TRN_PERMISSIONS_SEARCH_FETCH_FULFILLED = 'TRN_PERMISSIONS_SEARCH_FETCH_FULFILLED'

export const permissionsSearchFetch = (entityId, searchKey) => ({
  payload: { entityId, searchKey },
  type: TRN_PERMISSIONS_SEARCH_FETCH,
})

export const permissionsSearchFetchFulfilled = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_SEARCH_FETCH_FULFILLED,
})

export const permissionsSearchFetchCanceled = () => ({
  payload: null,
  type: TRN_PERMISSIONS_SEARCH_FETCH_CANCELED,
})

export const permissionsSearchFetchError = (payload) => ({
  payload,
  type: TRN_PERMISSIONS_SEARCH_FETCH_ERROR,
})

export const permissionsSearchFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_PERMISSIONS_SEARCH_FETCH),
    debounceTime(700), // wait for 0.7 seconds before change your main
    mergeMap((action) =>
      epicServerRequest(
        'get',
        `${APP.api_url}/permissions/${action.payload.entityId}/${action.payload.searchKey}`,
        action,
      ).pipe(
        map(epicResponseHandler(permissionsSearchFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_PERMISSIONS_SEARCH_FETCH, TRN_PERMISSIONS_SEARCH_FETCH_CANCELED))),
        catchError(epicErrorHandler(permissionsSearchFetchError, action)),
      ),
    ),
  )
